export function initFormContact() {
  const formContainer = document.getElementById('form-contact');
  if (!formContainer) return;

  const form = formContainer.querySelector('.form-contact');
  if (!form) return;

  const successClass = 'success';
  const resendLink = formContainer.querySelector('.link');
  const submitButton = form.querySelector('button[type="submit"]');
  const testApiUrl = form.getAttribute('action');
  const thanksMessage = formContainer.querySelector('.thanks-message');
  const thanksParagraph = thanksMessage?.querySelector('p');
  const thanksEmail = thanksParagraph?.querySelector('strong');
  const emailField = form.querySelector('input[type="email"], input[name*="email" i], input[id*="email" i]');

  if (!submitButton || !testApiUrl) return;

  const setThanksMessageVisibility = (isVisible) => {
    if (!thanksMessage) return;

    if (isVisible) {
      thanksMessage.removeAttribute('aria-hidden');
      thanksMessage.removeAttribute('inert');
      return;
    }

    thanksMessage.setAttribute('aria-hidden', 'true');
    thanksMessage.setAttribute('inert', '');
  };

  const isValidEmail = (email) => {
    if (!email) return false;

    const normalizedEmail = email.trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail);
  };

  const setThanksParagraphState = (email) => {
    const normalizedEmail = email.trim();
    const hasValidEmail = isValidEmail(normalizedEmail);

    if (thanksParagraph) {
      thanksParagraph.hidden = !hasValidEmail;
      thanksParagraph.setAttribute('aria-hidden', hasValidEmail ? 'false' : 'true');
    }

    if (thanksEmail) {
      thanksEmail.textContent = hasValidEmail ? normalizedEmail : '';
    }
  };

  const buildPayload = () => {
    const payload = {};
    const fields = form.querySelectorAll('input, select, textarea');

    for (const field of fields) {
      const key = field.name || field.id;
      if (!key) continue;

      if (field.type === 'checkbox') {
        payload[key] = field.checked;
      } else {
        payload[key] = field.value;
      }
    }

    return payload;
  };

  const resetSuccessState = () => {
    formContainer.classList.remove(successClass);
    form.reset();
    setThanksParagraphState('');
    setThanksMessageVisibility(false);
  };

  setThanksMessageVisibility(false);
  setThanksParagraphState('');

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    submitButton.disabled = true;

    try {
      const response = await fetch(testApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildPayload()),
      });

      if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
      }

      const emailValue = emailField?.value.trim() || '';
      setThanksParagraphState(emailValue);
      formContainer.classList.add(successClass);
      setThanksMessageVisibility(true);
    } catch (error) {
      console.error('Contact form submit error:', error);
    } finally {
      submitButton.disabled = false;
    }
  });

  if (resendLink) {
    resendLink.addEventListener('click', (event) => {
      event.preventDefault();
      resetSuccessState();
    });
  }
}
